import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { uniformeModulo } from "src/app/aplicaciones-modulos/spyral/diccionarios/uniformeModule";
import { ClaveValorModel } from 'src/app/aplicaciones-modulos/sustentos/models/claveValorModel';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { Caracteristica } from '../../model/caracteristicaModel';
import { EmployeModel } from '../../model/employeModel';
import { StatusProcessModel } from '../../model/statusProcessModel';
import { CaracteristicaService } from '../../services/caracteristica.service';
import { OnlyControlService } from '../../services/only-control.service';

@Component({
  selector: 'app-data-ldap',
  templateUrl: './data-ldap.component.html',
  styleUrls: ['./data-ldap.component.css']
})
export class DataLdapComponent implements OnInit {

  mostrarFormulario: boolean = false;
  chkCmbArea: boolean = false;
  chkCmbLocalidad: boolean = false;
  chkCmbEmpleado: boolean = false;
  resposiveFull: string;
  clothesModulo: any = {};

  formulario: FormGroup;

  cmbOpcionesArea: ClaveValorModel[] = [];
  cmbOpcionesLocalidad: ClaveValorModel[] = [];
  cmbOpcionesEmpleado: ClaveValorModel[] = [];
  loading: boolean = false;

  constructor(private fb: FormBuilder, private _util: UtilsService,
    private _caracteristica: CaracteristicaService,
    private _only: OnlyControlService) { }

  ngOnInit() {
    this.clothesModulo = uniformeModulo;
    this.resposiveFull = this.clothesModulo.div.resposiveFull;

    this.formulario = this.fb.group({
      area: [''],
      localidad: [''],
      empleado: [''],
    });

    this.getAllDepartamento();
    this.getAllLocalidad();

  }

  changeCmbArea() {
    this.chkCmbArea = !this.chkCmbArea;
    this.getAllEmpleado();
  }

  changeCmbLocalidad() {
    this.chkCmbLocalidad = !this.chkCmbLocalidad;
    this.getAllEmpleado();
  }

  changeCmbEmpleado() {
    this.chkCmbEmpleado = !this.chkCmbEmpleado;
  }

  updateFotoEmpleado() {
    if (this.chkCmbArea != true && (this.formulario.get('area').value == undefined || this.formulario.get('area').value == '')) {
      this._util.mensajeErrorVisto("Debe seleccionar un/todas Area");
    } else if (this.chkCmbLocalidad != true && (this.formulario.get('localidad').value == undefined || this.formulario.get('localidad').value == '')) {
      this._util.mensajeErrorVisto("Debe seleccionar un/todas Localidad");
    } else if (this.chkCmbEmpleado != true && (this.formulario.get('empleado').value == undefined || this.formulario.get('empleado').value == '')) {
      this._util.mensajeErrorVisto("Debe seleccionar un/todos Empleado");
    } else {
      this._util.confirmarSincronoPromesaNormal(
        {
          title: 'Esta seguro que desea actualziar la foto al/los empleados?',
          text: '',
          action: 'Enviar',
          funcion: this._only.uodatePhotoDA((this.chkCmbArea ? 'ALL' : this.formulario.get('area').value),
            (this.chkCmbLocalidad ? 'ALL' : this.formulario.get('localidad').value),
            (this.chkCmbEmpleado ? 'ALL' : this.formulario.get('empleado').value)),
          loading: true,
          context: this,
        }
      ).then((res: any) => {
        this.formulario.reset();
      }).catch((err) => {
        console.log('Error ' + err);
      });
    }
  }

  updateInfoEmploye() {
    if (this.chkCmbArea != true && (this.formulario.get('area').value == undefined || this.formulario.get('area').value == '')) {
      this._util.mensajeErrorVisto("Debe seleccionar un/todas Area");
    } else if (this.chkCmbLocalidad != true && (this.formulario.get('localidad').value == undefined || this.formulario.get('localidad').value == '')) {
      this._util.mensajeErrorVisto("Debe seleccionar un/todas Localidad");
    } else if (this.chkCmbEmpleado != true && (this.formulario.get('empleado').value == undefined || this.formulario.get('empleado').value == '')) {
      this._util.mensajeErrorVisto("Debe seleccionar un/todos Empleado");
    } else {
      this._util.confirmarSincronoPromesaNormal(
        {
          title: 'Esta seguro que desea actualziar al/los empleados?',
          text: '',
          action: 'Enviar',
          funcion: this._caracteristica.sincroDa((this.chkCmbArea ? 'ALL' : this.formulario.get('area').value),
            (this.chkCmbLocalidad ? 'ALL' : this.formulario.get('localidad').value),
            (this.chkCmbEmpleado ? 'ALL' : this.formulario.get('empleado').value)),
          loading: true,
          context: this,
        }
      ).then((res: any) => {
        this.formulario.reset();
      }).catch((err) => {
        console.log('Error ' + err);
      });
    }
  }

  getAllDepartamento() {
    this.cmbOpcionesArea = [];
    this._caracteristica.getAllDepartamento().subscribe((res: Caracteristica[]) => {
      res.forEach((item) => {
        this.cmbOpcionesArea.push({ clave: item.codigo, valor: item.descripcion + ' (' + item.codigo + ')' });
      });
    }, (err) => {
      console.log(err);
      this.cmbOpcionesArea = [];
      if (err.error.key == '500') {
        this._util.mensajeErroToast(err.error.message);
      } else {
        this._util.mensajeErroToast('No se encontro información.');
      }
    });
  }

  getAllLocalidad() {
    this.cmbOpcionesLocalidad = [];
    this._caracteristica.getAllLocalidad().subscribe((res: Caracteristica[]) => {
      res.forEach((item) => {
        this.cmbOpcionesLocalidad.push({ clave: item.codigo, valor: item.descripcion + ' (' + item.codigo + ')' });
      });
    }, (err) => {
      console.log(err);
      this.cmbOpcionesLocalidad = [];
      if (err.error.key == '500') {
        this._util.mensajeErroToast(err.error.message);
      } else {
        this._util.mensajeErroToast('No se encontro información.');
      }
    });
  }

  getAllEmpleado() {
    debugger;
    this.cmbOpcionesEmpleado = [];
    if (this.chkCmbArea == true && this.chkCmbLocalidad == true) {
      this._caracteristica.getAllEmpleado().subscribe((res: EmployeModel[]) => {
        res.forEach((item) => {
          this.cmbOpcionesEmpleado.push({ clave: item.cedula, valor: item.nombres + ' (' + item.cedula + ')' });
        });
      }, (err) => {
        console.log(err);
        this.cmbOpcionesEmpleado = [];
        if (err.error.key == '500') {
          this._util.mensajeErroToast(err.error.message);
        } else {
          this._util.mensajeErroToast('No se encontro información.');
        }
      });
    } else if (this.chkCmbArea == true && this.chkCmbLocalidad == false) {

      if (this.formulario.get('localidad').value == undefined || this.formulario.get('localidad').value == '') {
        this._util.mensajeErroToast('No ha seleccionado Localidad.');
      } else {
        this._caracteristica.findEmpleadoByLocalidad(this.formulario.get('localidad').value).subscribe((res: EmployeModel[]) => {
          res.forEach((item) => {
            this.cmbOpcionesEmpleado.push({ clave: item.cedula, valor: item.nombres + ' (' + item.cedula + ')' });
          });
        }, (err) => {
          console.log(err);
          this.cmbOpcionesEmpleado = [];
          if (err.error.key == '500') {
            this._util.mensajeErroToast(err.error.message);
          } else {
            this._util.mensajeErroToast('No se encontro información.');
          }
        });
      }

    } else if (this.chkCmbArea == false && this.chkCmbLocalidad == true) {

      if (this.formulario.get('area').value == undefined || this.formulario.get('area').value == '') {
        this._util.mensajeErroToast('No ha seleccionado Departamento.');
      } else {
        this._caracteristica.findEmpleadoByDepartamento(this.formulario.get('area').value).subscribe((res: EmployeModel[]) => {
          res.forEach((item) => {
            this.cmbOpcionesEmpleado.push({ clave: item.cedula, valor: item.nombres + ' (' + item.cedula + ')' });
          });
        }, (err) => {
          console.log(err);
          this.cmbOpcionesEmpleado = [];
          if (err.error.key == '500') {
            this._util.mensajeErroToast(err.error.message);
          } else {
            this._util.mensajeErroToast('No se encontro información.');
          }
        });
      }

    } else if (this.chkCmbArea == false && this.chkCmbLocalidad == false) {

      if (this.formulario.get('area').value == undefined || this.formulario.get('area').value == '') {
        this._util.mensajeErroToast('No ha seleccionado Departamento.');
      } else if (this.formulario.get('localidad').value == undefined || this.formulario.get('localidad').value == '') {
        this._util.mensajeErroToast('No ha seleccionado Localidad.');
      } else {
        this._caracteristica.findEmpleadoByDepLoc(this.formulario.get('area').value, this.formulario.get('localidad').value).subscribe((res: EmployeModel[]) => {
          res.forEach((item) => {
            this.cmbOpcionesEmpleado.push({ clave: item.cedula, valor: item.nombres + ' (' + item.cedula + ')' });
          });
        }, (err) => {
          console.log(err);
          this.cmbOpcionesEmpleado = [];
          if (err.error.key == '500') {
            this._util.mensajeErroToast(err.error.message);
          } else {
            this._util.mensajeErroToast('No se encontro información.');
          }
        });
      }

    }
  }

  getSyncProcess() {
    this._caracteristica.getSyncStatus().subscribe((res: StatusProcessModel) => {
      this.getStatusMensaje(res.statusUpdate);
    }, (err) => {
      this._util.mensajeErroToast(err.error.message);
    });
  }

  getStatusFotoEmpleado() {
    this._only.getStatusPhotoDA().subscribe((res: StatusProcessModel) => {
      this.getStatusMensaje(res.statusUpdate);
    }, (err) => {
      this._util.mensajeErroToast(err.error.message);
    });
  }

  getStatusMensaje(statusUpdate) {
    let msn: string;
    switch (statusUpdate) {
      case 0:
        msn = 'El proceso de actualización se realizó correctamente.';
        this._util.mensajeOKVisto(msn, true, 10000);
        break;
      case 1:
        msn = 'El proceso de actualización se detuvo comuníquese con el administrador.';
        this._util.mensajeErrorVisto(msn, true, 10000);
        break;
      case 2:
        msn = 'El proceso de actualización se sigue ejecutando.';
        this._util.mensajeErrorVisto(msn, true, 10000);
        break;
      default:
        break;
    }
  }

}
